import { Pipe, PipeTransform } from "@angular/core";

const KPI_DAYS_KEYS: Record<number, string> = {
  1: "Wireless.Stats.Today",
  3: "Wireless.Stats.3Days",
  7: "Wireless.Stats.LastWeek",
};

@Pipe({
  name: "kpiDaysKey",
})
export class KpiDaysKeyPipe implements PipeTransform {
  transform(days: number): string {
    return KPI_DAYS_KEYS[days] ?? "Wireless.Stats.Today";
  }
}
